;(function(jQuery) {
	'use strict';

	function NewsletterSignup() {
		var fn = {
			init: function()
			{
				jQuery('.js-subscribe-form').on('submit', fn.handleNewsletterSignupSubmission);
			},

			handleNewsletterSignupSubmission: function(e)
			{
				e.preventDefault();

				var form = jQuery(e.target);
				var data = form.serializeArray();
				var context = form.attr('data-context');

				jQuery.post(flocertajax, data)
					.done(function(data)
					{
						if (context === 'portal-notifications-popup')
						{
							jQuery('.js-portal-modal').data('preference', data.payload.preference_type);

							var text = jQuery('.portal-modal__text');
							text.children().remove();
							form.children().remove();
							var msg = '<h1 class="portal-modal__heading">' + data.payload.message + '</h1><p>' + data.payload.subtext + '</p>';
							text.append(msg);
						}
						else
						{
							form.children().remove();
							var msg = '<span class="footer-form-message__success"><strong>' + data.payload.message + '</strong></span> ' + data.payload.subtext;
							form.append('<div class="footer-form-message">' + msg + '</div>')
						}
					})
					.fail(function( data )
					{
						console.error('AJAX error with data : '+ data);
					});
			},
		};

		jQuery(fn.init());
	}

	new NewsletterSignup();
}(jQuery));